import { useContext } from 'react';
import { TreeViewContext } from '@/components/TreeView/Context';

export const useTreeViewContext = () => {
  return useContext(TreeViewContext);
};